import apiClient from './apiClient';

class DevCapacityService {
  async getProjectDevelopers(projectId) {
    try {
      return await apiClient.get(`/projects/${projectId}/developers`);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch team members');
    }
  }

  async getRoleOptions(projectId) {
    try {
      const data = await apiClient.get(`/projects/${projectId}/developers/role_options`);
      return data ?? { role_types: [], roles: [] };
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to fetch role options');
    }
  }

  async addDeveloper(projectId, developerData) {
    try {
      return await apiClient.post(`/projects/${projectId}/developers`, developerData);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to add team member');
    }
  }

  async removeDeveloper(projectId, projectDeveloperId) {
    try {
      return await apiClient.delete(`/projects/${projectId}/developers/${projectDeveloperId}`);
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to remove team member');
    }
  }

  async updateDeveloper(projectId, projectDeveloperId, { maxHoursPerWeek, weeklyHours, weeks }) {
    try {
      return await apiClient.patch(
        `/projects/${projectId}/developers/${projectDeveloperId}`,
        {
          max_hours_per_week: maxHoursPerWeek,
          weekly_hours: weeklyHours,
          weeks,
        }
      );
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to update team member');
    }
  }

  async updateCapacities(projectId, projectDeveloperId, weeklyHours, weeks) {
    try {
      return await apiClient.patch(
        `/projects/${projectId}/developers/${projectDeveloperId}/capacities`,
        { weekly_hours: weeklyHours, weeks }
      );
    } catch (error) {
      const err = error.response?.data;
      throw new Error(err?.error || 'Failed to update capacities');
    }
  }
}

export const devCapacityService = new DevCapacityService();
